import React, { useState } from "react";
import CartDrawer from "../AdminComponents/CartDrawer";
import DrawerTitle from "./DrawerTitle";
import DoctorWhishList from "../AllTabs/Whishlist/DoctorWhishList";
import TestsWhishList from "../AllTabs/Whishlist/TestsWhishList";
import PackagesWhishList from "../AllTabs/Whishlist/PackagesWhishList";
import PharmaWhishList from "../AllTabs/Whishlist/PharmaWhishList";
import AtHomeServiceWhishList from "../AllTabs/Whishlist/AtHomeServiceWhishList";
import HomeCareAppointementScreen from "../AllTabs/HomeCare/HomeCareAppointementScreen";
import TabsSlideContainer from "../GlobalComponents/Widget/TabsSlideContainer";

const WhishlistDrawer = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const [activeTab, setActiveTab] = useState<string>("My Doctors");
  const [bookAppointementId, setBookAppointementId] = useState<string | null>(
    null
  );
  const [success, setSuccess] = useState<boolean>(false);
  let tabs = [
    { name: "My Doctors", value: "my-doctors", count: 0 },
    { name: "Tests", value: "tests", count: 0 },
    { name: "Packages", value: "packages", count: 0 },
    { name: "Pharma Products", value: "pharma-products", count: 0 },
    { name: "At Home Services", value: "at-home-service", count: 0 },
  ];

  return (
    <CartDrawer
      showModal={success}
      modalContent={{
        title: "Thank You!",
        description: `Your appointment has been confirm.`,
      }}
      isOpen={isOpen}
      onClose={() => {
        onClose();
        setSuccess(false);
      }}
      className={ `!bg-[#F6FAFF]`}
    >
      {bookAppointementId && (
        <HomeCareAppointementScreen
          id={bookAppointementId}
          onBack={() => {
            setBookAppointementId(null);
            setSuccess(false);
          }}
          onSuccess={() => {
            setBookAppointementId(null);
            setSuccess(true);
          }}
        />
      )}
      <div className={`${bookAppointementId ? "hidden" : ""}`}>
        <DrawerTitle title={"Wishlist"} />
        {/* Navigation Tabs */}
        <div className="w-full  flex flex-col p-2 2xl:p-4 gap-2 2xl:gap-4">
          <div className="flex gap-2 overflow-x-auto overflow-y-hidden scroll-hide">
            <TabsSlideContainer
              tabs={tabs}
              activeTab={tabs.find((tab) => tab.name === activeTab) || tabs[0]}
              onChange={(tab) => setActiveTab(tab.name || "")}
            />
          </div>

          {/* Doctor Cards */}
          <div className="w-full flex  flex-col gap-2 2xl:gap-4">
            {activeTab === "My Doctors" && (
              <DoctorWhishList onClose={onClose} />
            )}
            {activeTab === "Tests" && <TestsWhishList onClose={onClose} />}
            {activeTab === "Packages" && (
              <PackagesWhishList onClose={onClose} />
            )}
            {activeTab === "Pharma Products" && (
              <PharmaWhishList onClose={onClose} />
            )}
            {activeTab === "At Home Services" && (
              <AtHomeServiceWhishList
                onClose={onClose}
                onAppointmentClick={(id) => {
                  setBookAppointementId(id || null);
                }}
              />
            )}
          </div>
        </div>
      </div>
    </CartDrawer>
  );
};

export default WhishlistDrawer;
